<template>
  <div>
    <div class="vx-col w-full mb-base">
      <vs-card class="p-4 mb-6 tvd-card">
        <div slot="header" class="flex flex-wrap items-center justify-between">
          <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
            <h4>TVD Support Tools</h4>
          </div>
          <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
            <vs-button
              color="primary"
              type="filled"
              icon="icon-book-open"
              icon-pack="feather"
              class="btn"
              @click="showPanduan = true"
            >
              Panduan
            </vs-button>
          </div>
        </div>

        <div class="tvd-body">
          <!-- Sidebar Navigation (desktop) / Tab Bar (mobile) -->
          <div class="tvd-sidebar" ref="tvdSidebar">
            <div
              v-for="(menu, index) in menus"
              :key="index"
              :ref="'navItem' + index"
              class="tvd-nav-item"
              :class="{ 'tvd-nav-active': activeMenu === index }"
              @click="selectMenu(index)"
            >
              <div
                class="tvd-nav-icon"
                :style="{ background: menu.color + '15', color: menu.color }"
              >
                <i :class="menu.icon"></i>
              </div>
              <div class="tvd-nav-label">{{ menu.name }}</div>
            </div>
          </div>

          <!-- Content Area -->
          <div class="tvd-content">
            <change-inbound-reference v-if="activeMenu === 0" @loading="onLoading" @error="onError" />
            <change-good-receive-reference v-if="activeMenu === 1" @loading="onLoading" @error="onError" />
            <change-serial-number v-if="activeMenu === 2" @error="onError" />
            <change-warehouse v-if="activeMenu === 3" @error="onError" />
            <change-outbound-delivery-order v-if="activeMenu === 4" @loading="onLoading" @error="onError" />
            <change-outbound-reference v-if="activeMenu === 5" @loading="onLoading" @error="onError" />
            <change-do-reference v-if="activeMenu === 6" @loading="onLoading" @error="onError" />
            <change-inbound-notes v-if="activeMenu === 7" @loading="onLoading" @error="onError" />
            <adjust-bracket-inventory v-if="activeMenu === 8" @loading="onLoading" @error="onError" />
             <cancel-gi-based-on-do v-if="activeMenu === 9" @loading="onLoading" @error="onError" />
            <cancel-gi-partial v-if="activeMenu === 10" @loading="onLoading" @error="onError" />
            <stock-transfer-warehouse v-if="activeMenu === 11" @loading="onLoading" @error="onError" />
            <change-serial-number-gi-twh v-if="activeMenu === 12" @error="onError" />
            <sn-anomaly-report v-if="activeMenu === 13" @error="onError" />
            <lacak-sn v-if="activeMenu === 14" @error="onError" />
            <close-outbound v-if="activeMenu === 15" @loading="onLoading" @error="onError" />
          </div>
        </div>
      </vs-card>
    </div>

    <PanduanTVD :active.sync="showPanduan" />
  </div>
</template>

<script>
import ChangeInboundReference from "./tabs/ChangeInboundReference.vue";
import ChangeGoodReceiveReference from "./tabs/ChangeGoodReceiveReference.vue";
import ChangeSerialNumber from "./tabs/ChangeSerialNumber.vue";
import ChangeWarehouse from "./tabs/ChangeWarehouse.vue";
import CancelGoodIssue from "./tabs/CancelGoodIssue.vue";
import CancelGiBasedOnDo from "./tabs/CancelGiBasedOnDo.vue";
import CancelGiPartial from "./tabs/CancelGiPartial.vue";
import ChangeOutboundDeliveryOrder from "./tabs/ChangeOutboundDeliveryOrder.vue";
import ChangeOutboundReference from "./tabs/ChangeOutboundReference.vue";
import ChangeDoReference from "./tabs/ChangeDoReference.vue";
import ChangeInboundNotes from "./tabs/ChangeInboundNotes.vue";
import AdjustBracketInventory from "./tabs/SyncBracketInventory.vue";
import StockTransferWarehouse from "./tabs/StockTransferWarehouse.vue";
import ChangeSerialNumberGiTwh from "./tabs/ChangeSerialNumberGiTwh.vue";
import SnAnomalyReport from "./tabs/SnAnomalyReport.vue";
import LacakSn from "./tabs/LacakSn.vue";
import CloseOutbound from "./tabs/CloseOutbound.vue";
import PanduanTVD from "./PanduanTVD.vue";

export default {
  components: {
    ChangeInboundReference,
    ChangeGoodReceiveReference,
    ChangeSerialNumber,
    ChangeWarehouse,
    CancelGoodIssue,
    CancelGiBasedOnDo,
    CancelGiPartial,
    ChangeOutboundDeliveryOrder,
    ChangeOutboundReference,
    ChangeDoReference,
    ChangeInboundNotes,
    AdjustBracketInventory,
    StockTransferWarehouse,
    ChangeSerialNumberGiTwh,
    SnAnomalyReport,
    LacakSn,
    CloseOutbound,
    PanduanTVD,
  },
  data() {
    return {
      isLoading: false,
      activeMenu: 0,
      showPanduan: false,
      menus: [
        { name: "Change Inbound Reference", icon: "feather icon-edit-2", color: "#6c63ff" },
        { name: "Change GR Reference", icon: "feather icon-refresh-cw", color: "#00b894" },
        { name: "Change Serial Number", icon: "feather icon-hash", color: "#e17055" },
        { name: "Change Warehouse", icon: "feather icon-home", color: "#0984e3" },
        { name: "Change Delivery Order's Outbound", icon: "feather icon-truck", color: "#d63031" },
        { name: "Change Outbound Reference", icon: "feather icon-repeat", color: "#2d98da" },
        { name: "Change DO Reference", icon: "feather icon-truck", color: "#9b59b6" },
        { name: "Change Inbound Notes", icon: "feather icon-file-text", color: "#636e72" },
        { name: "Sync Bracket Inventory", icon: "feather icon-refresh-cw", color: "#f39c12" },
        { name: "Cancel Good Issue Based on DO", icon: "feather icon-x-circle", color: "#e84393" },
        { name: "Cancel GI Partial", icon: "feather icon-x-circle", color: "#e84393" },
        { name: "Warehouse Stock Transfer", icon: "feather icon-shuffle", color: "#009688" },
        { name: "Change Serial Number on GI/TWH", icon: "feather icon-grid", color: "#e17055" },
        { name: "SN Anomaly Report", icon: "feather icon-alert-triangle", color: "#d63031" },
        { name: "Lacak Serial Number", icon: "feather icon-search", color: "#0984e3" },
        { name: "Close Outbound", icon: "feather icon-check-circle", color: "#27ae60" },
      ],
    };
  },
  watch: {
    isLoading: function () {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
  },
  methods: {
    selectMenu(index) {
      this.activeMenu = index;
      this.$nextTick(() => {
        // Desktop-only (CSS mobile: max-width 768px): di mobile top bar horizontal, tanpa reset scroll.
        if (!window.matchMedia("(min-width: 769px)").matches) return;
        const sidebar = this.$refs.tvdSidebar;
        if (sidebar) sidebar.scrollTo({ top: 0, behavior: "smooth" });
        const content = this.$el.querySelector(".tvd-content");
        if (content) content.scrollTo({ top: 0 });
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    },
    onLoading(state) {
      this.isLoading = state;
    },
    onError(error) {
      this.handleError(error);
    },
  },
};
</script>

<style scoped>
.tvd-body {
  display: flex;
  min-height: 500px;
  border: 1px solid #eee;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 12px;
}

/* Sidebar */
.tvd-sidebar {
  width: 230px;
  flex-shrink: 0;
  border-right: 1px solid #eee;
  overflow-y: auto;
  background: #fafafa;
  padding: 8px 0;
}
.tvd-nav-item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  cursor: pointer;
  transition: all 0.15s ease;
  border-left: 3px solid transparent;
}
.tvd-nav-item:hover {
  background: #f0f0f5;
}
.tvd-nav-active {
  background: #eef0ff !important;
  border-left-color: #6c63ff;
}
.tvd-nav-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  font-size: 15px;
  flex-shrink: 0;
}
.tvd-nav-label {
  font-size: 13px;
  font-weight: 500;
  color: #333;
  line-height: 1.3;
}
.tvd-nav-active .tvd-nav-label {
  font-weight: 600;
  color: #6c63ff;
}

/* Content */
.tvd-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px 20px;
}

/* Scrollbar */
.tvd-content::-webkit-scrollbar,
.tvd-sidebar::-webkit-scrollbar {
  width: 6px;
}
.tvd-content::-webkit-scrollbar-track,
.tvd-sidebar::-webkit-scrollbar-track {
  background: transparent;
}
.tvd-content::-webkit-scrollbar-thumb,
.tvd-sidebar::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 3px;
}
</style>

<style>
/* Mobile: sidebar becomes horizontal tab bar (unscoped for Vuesax override) */
@media (max-width: 768px) {
  .tvd-card .vs-card--body {
    padding: 12px 8px !important;
    overflow-x: hidden !important;
  }
  .tvd-card .tvd-body {
    flex-direction: column !important;
    min-height: auto !important;
    border: none !important;
    overflow: visible !important;
  }
  .tvd-card .tvd-sidebar {
    width: 100% !important;
    flex-shrink: 1 !important;
    border-right: none !important;
    border-bottom: 1px solid #eee !important;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    -webkit-overflow-scrolling: touch;
    display: flex !important;
    flex-wrap: nowrap !important;
    padding: 6px !important;
    gap: 6px !important;
    background: #fafafa !important;
  }
  .tvd-card .tvd-sidebar::-webkit-scrollbar {
    height: 0 !important;
    display: none !important;
  }
  .tvd-card .tvd-nav-item {
    display: inline-flex !important;
    align-items: center !important;
    flex-shrink: 0 !important;
    padding: 7px 12px !important;
    min-width: fit-content !important;
    white-space: nowrap !important;
    border-left: none !important;
    border-bottom: 3px solid transparent !important;
    border-radius: 6px !important;
    cursor: pointer !important;
    transition: all 0.15s ease !important;
  }
  .tvd-card .tvd-nav-item:hover {
    background: transparent !important;
  }
  .tvd-card .tvd-nav-active {
    border-left-color: transparent !important;
    border-bottom-color: #6c63ff !important;
    background: #eef0ff !important;
  }
  .tvd-card .tvd-nav-icon {
    margin-right: 6px !important;
    width: 24px !important;
    height: 24px !important;
    font-size: 13px !important;
    border-radius: 6px !important;
    flex-shrink: 0 !important;
  }
  .tvd-card .tvd-nav-label {
    font-size: 11px !important;
    font-weight: 500 !important;
    color: #333 !important;
    line-height: 1.2 !important;
  }
  .tvd-card .tvd-nav-active .tvd-nav-label {
    font-weight: 600 !important;
    color: #6c63ff !important;
  }
  .tvd-card .tvd-content {
    flex: 1 !important;
    width: 100% !important;
    padding: 12px 6px !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
  }
}
</style>
